import React, { useEffect, useState } from 'react';
import './Hero.css';

const Hero = () => {
    const [scrollY, setScrollY] = useState(0);

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const heroHeight = 800;  // Hero section height
    const textHeight = 100;  // Height of text block

    const scrollPosition = Math.min(
        scrollY * 0.5,  // Speed of scroll effect
        heroHeight - textHeight  // Don't let it go past the bottom
    );

    const finalPosition = Math.max(0, Math.min(scrollPosition, heroHeight - textHeight));

    return (
        <div className="hero-container" id="home">
            <div className="hero-foreground"></div>

            <div className="hero-background"></div>

            <div
                className="hero-text"
                style={{
                    transform: `translate(-50%, calc(-50% + ${finalPosition}px))`, // Move the text with scroll
                }}
            >
                <p>ΕΛΑΤΑ</p>
                <p>ΑΦΟΙ</p>
                <p>ΜΑΛΑΝΔΡΗ</p>
            </div>
        </div>
    );
};

export default Hero;
